import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function TransformationSection() {
  const {
    lang
  } = useLanguage();
  const shifts = [{
    from: 'Una presencia genérica que no transmite quién eres.',
    fromEn: "A generic presence that doesn't convey who you are.",
    to: 'Una identidad digital que comunica tu valor antes de hablar.',
    toEn: 'A digital identity that communicates your value before you speak.'
  }, {
    from: 'Improvisar sin sistema ni dirección clara.',
    fromEn: 'Improvising without a system or clear direction.',
    to: 'Un negocio con estrategia, claridad y propósito.',
    toEn: 'A business with strategy, clarity, and purpose.'
  }, {
    from: 'Atraer a las personas equivocadas.',
    fromEn: 'Attracting the wrong people.',
    to: 'Atraer a los clientes que realmente valoran lo que haces.',
    toEn: 'Attracting the clients who truly value what you do.'
  }];
  return <section id="transformacion" className="py-32 lg:py-44 bg-inkova-cream" data-id="element-427">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-428">
        <div className="text-center mb-20 max-w-2xl mx-auto" data-id="element-429">
          <span className="block font-sans text-[11px] font-semibold tracking-[3px] uppercase text-inkova-primary mb-8" data-id="element-430">
            {lang === 'es' ? 'LA TRANSFORMACIÓN' : 'THE TRANSFORMATION'}
          </span>
          <h2 className="font-serif text-[32px] sm:text-[4vw] lg:text-[48px] leading-[1.1] tracking-[-0.5px] text-inkova-dark" data-id="element-431">
            {lang === 'es' ? <>
                De donde estás, a donde{' '}
                <em className="italic text-inkova-lavender" data-id="element-432">mereces</em> estar.
              </> : <>
                From where you are, to where you{' '}
                <em className="italic text-inkova-lavender" data-id="element-433">deserve</em> to be.
              </>}
          </h2>
        </div>

        <div className="flex flex-col gap-px bg-inkova-border rounded-[24px] overflow-hidden border border-inkova-border" data-id="element-434">
          {shifts.map((shift, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9,
          ease: 'easeOut',
          delay: index * 0.1
        }} className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-6 md:gap-10 items-center bg-inkova-cream px-8 lg:px-14 py-12" data-id="element-435">
              <p className="text-[16px] text-inkova-dark/45 font-light leading-[1.7] line-through decoration-inkova-dark/20" data-id="element-436">
                {lang === 'es' ? shift.from : shift.fromEn}
              </p>
              <span className="hidden md:block font-serif text-[28px] text-inkova-lavender italic" data-id="element-437">
                →
              </span>
              <p className="text-[18px] text-inkova-dark font-light leading-[1.7]" data-id="element-438">
                {lang === 'es' ? shift.to : shift.toEn}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}